import { queryOptions } from '@tanstack/react-query';

import {
  getAccountReceivableClientAggregatesQuery,
  getAccountReceivableQuery,
  getAccountReceivablesQuery,
} from './shared';

export const getAccountReceivableQueryOptions = (id: string) => queryOptions(getAccountReceivableQuery(id));

export const getAccountReceivablesQueryOptions = (apiParamStr?: string) =>
  queryOptions(getAccountReceivablesQuery(apiParamStr));

export const getAccountReceivableClientAggregatesQueryOptions = (apiParamStr?: string) =>
  queryOptions(getAccountReceivableClientAggregatesQuery(apiParamStr));
